module.exports = __webpack_public_path__ + "static/media/uruguay.b322f181.svg";